<template>
  <div>
    <spinner :visible.sync="this.loading" :overlay="true"></spinner>
    <div class="config-row">
      <div class="config-col from">
        <h4>{{ i18nJS.drugs_configs.swap.from }}</h4>
        <v-select2
          v-model="drugsFrom"
          :data-ajax--url="drugsUrl"
          :data-minimumInputLength="1"
          :data-placeholder="i18nJS.drugs_configs.swap.from_ph"
          @input="drugSourceSelected"
          :class="'full-width'"
        />
      </div>
      <i class="fa fa-right-right config-col middle"></i>
      <div class="config-col to">
        <h4>{{ i18nJS.drugs_configs.swap.to }}</h4>
        <v-select2
          v-model="drugsTo"
          id="drugsTo--select"
          :disabled="drugsToDisabled"
          :data-ajax--url="drugsUrl"
          :data-minimumInputLength="1"
          :data-placeholder="i18nJS.drugs_configs.swap.to_ph"
          @input="resetPreview"
          :class="'full-width'"
        />
      </div>
    </div>
    <div class="config-row">
      <div class="guest_drugs_involved_count">
        <span v-show="guestDrugsInvolvedCount != null"
          >{{ this.previewLoaded ? i18nJS.drugs_configs.swap.selected : i18nJS.drugs_configs.swap.involved }}: {{ this.countInvSel }}</span
        >
      </div>
    </div>
    <div class="config-row swap_from-row">
      <div class="config-col swap_from">
        <label for="swap_from" v-html="i18nJS.drugs_configs.swap.swap_from_html"></label>
        <datepicker
          class="obbligatorio"
          ref="swapDateInput"
          :key="updateDate"
          :value="swap_from"
          :min-date="minDate"
          @input="swapDateChange"
        />
        <div class="cta">
          <a
            v-show="swap_from"
            @click="action"
            :disabled="ctaDisabled"
            href="#"
            class="btn btn-primary"
            :class="{ forbidden: ctaDisabled }"
            >{{ btnLabel }}</a
          >
        </div>
      </div>
    </div>
    <hr />
    <div class="preview-area">
      <ol v-show="previewLoaded && !updateOk && !updateKo">
        <li class="header">
          <div class="sel">
            <input
              type="checkbox"
              id="selAll"
              :checked="allSelected"
              ref="checkAll"
              @click="toggleAll"
              :disabled="!(this.guestDrugs && this.guestDrugs.length)"
            />
            <label for="selAll" class="cb-label">Sostituire?</label>
          </div>
          <div class="fn">{{ i18nJS.fullname }}</div>
          <div class="via-and-form">
            <div class="via">{{ i18nJS.somm_type }}</div>
            <div class="form">{{ i18nJS.somm_form }}</div>
          </div>
          <div class="drug-and-periodicity">
            <div class="from--therapy">
              <div class="drug">{{ i18nJS.drugs_configs.swap.current_drug }}</div>
              <div class="periodicity"></div>
            </div>
            <div class="to--therapy">
              <div class="drug">{{ i18nJS.drugs_configs.swap.future_drug }}</div>
              <div class="periodicity"></div>
            </div>
          </div>
        </li>

        <li v-for="gd in guestDrugs" :key="gd.id" class="gd-involved">
          <div class="sel">
            <input type="checkbox" v-model="gd.selected" :id="`gd_${gd.id}`" />
            <label class="cb-label" :for="`gd_${gd.id}`"></label>
          </div>
          <div class="fn">{{ gd.full_name }}</div>
          <div class="via-and-form">
            <div class="via">{{ gd.get_somm_type }}</div>
            <div class="form">{{ gd.get_somm_form }}</div>
          </div>
          <div class="drug-and-periodicity">
            <div class="from--therapy">
              <div class="drug">{{ gd.drug_desc }}</div>
              <div class="periodicity">{{ gd.periodicity }} {{ gd.hours }}</div>
              <div class="from-to">
                {{ fromTo(gd) }}
              </div>
            </div>
            <div class="to--therapy" v-show="toBeClosed(gd)">
              <div class="drug">{{ gd.drug_desc }}</div>
              <div class="periodicity">{{ gd.periodicity }} {{ gd.hours }}</div>
              <div class="from-to">
                {{ fromTo(gd, true) }}
              </div>
            </div>
            <div class="to--therapy">
              <div class="drug">{{ gd.new_drug }}</div>
              <div class="periodicity">{{ gd.periodicity }} {{ gd.hours }}</div>
              <div class="from-to">
                {{ fromToNew(gd) }}
              </div>
            </div>
          </div>
        </li>
      </ol>
      <div class="box_msg alert alert-info" v-show="!previewLoaded">
        <div class="box_msg--msg" v-html="i18nJS.drugs_configs.swap.preview_info"></div>
      </div>
      <div class="center" v-show="updateOk">
        <label class="label">
          <input class="label__checkbox" type="checkbox" v-model="updateOkDelayed" @click="resetPreview()" />
          <span class="label__text">
            <span class="label__check">
              <i class="fa fa-check icon"></i>
            </span>
          </span>
        </label>
      </div>
      <div class="center" v-show="updateKo">
        <label class="label">
          <input class="label__checkbox" type="checkbox" v-model="updateKoDelayed" @click="closeError()" />
          <span class="label__text">
            <span class="label__check_ko">
              <i class="fa fa-xmark icon"></i>
            </span>
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import datepicker from '../datepicker';
import { escapeHtml } from '../../plugins/stringUtils';
import { Route } from '../../route';
import spinner from '../spinner';
import vSelect2 from '../vSelect2';

export default {
  name: 'drug-swap',
  data() {
    return {
      updateDate: false,
      loading: false,
      swap_from: null,
      drugsFrom: null,
      drugsTo: null,
      guestDrugsInvolvedCount: null,
      guestDrugs: [],
      minDate: new Date(moment().add(1, 'days').format()),
      updateOk: false,
      updateOkDelayed: false,
      updateKo: false,
      updateKoDelayed: false,
    };
  },
  props: {},
  components: {
    datepicker,
    spinner,
    vSelect2,
  },
  computed: {
    allSelected() {
      if (!this.guestDrugs) return false;

      return this.selGuestDrugs.length == this.guestDrugs.length;
    },
    btnLabel() {
      if (this.previewLoaded && !this.updateOk) {
        return i18nJS.drugs_configs.swap.submit.replace('__UTENTI__', this.selGuestDrugs.length);
      } else if (this.updateOk || this.updateKo) {
        return i18nJS.drugs_configs.swap.new_swap;
      } else {
        return i18nJS.drugs_configs.swap.show_preview;
      }
    },
    ctaDisabled() {
      return (
        this.drugsFrom == null ||
        this.drugsFrom == '' ||
        this.drugsTo == null ||
        this.drugsTo == '' ||
        (this.previewLoaded && this.selGuestDrugs.length == 0)
      );
    },
    countInvSel() {
      return this.previewLoaded ? `${this.selGuestDrugs.length} / ${this.guestDrugsInvolvedCount}` : this.guestDrugsInvolvedCount;
    },
    drugsToDisabled() {
      return this.drugsFrom == null || this.guestDrugsInvolvedCount == null || this.guestDrugsInvolvedCount == 0;
    },
    drugsUrl() {
      return `/${window.locale}/drugs/autocomplete_drug_nome_commerciale.json?without_page=true&aic`;
    },
    i18nJS() {
      return window.i18nJS;
    },
    previewLoaded() {
      return !!this.guestDrugs?.length;
    },
    selGuestDrugs() {
      return this.guestDrugs.filter((gd) => gd.selected).map((gd) => gd.id);
    },
    toTherapy() {
      return $('#drugsTo--select').val();
    },
  },
  mounted() {
    this.swap_from = moment.utc(moment.now()).add(1, 'days').format(i18nJS.time.formats.date_only);
  },
  methods: {
    action() {
      if (!this.ctaDisabled) {
        if (this.previewLoaded && !this.updateOk) {
          this.loading = true;
          if (this.selGuestDrugs.length > 0) {
            axios({
              method: 'post',
              url: Route.GUEST_DRUG_SWAP,
              data: {
                guest_drugs_swap: {
                  d_id_source: this.drugsFrom,
                  d_id_dest: this.drugsTo,
                  swap_from: this.swap_from,
                  ids: this.selGuestDrugs,
                },
              },
              headers: {
                'Content-type': 'application/json',
                'X-CSRF-Token': $.rails.csrfToken(),
              },
            })
              .then((res) => {
                this.updateOk = true;
                this.updateKo = false;
                this.updateOkDelayed = true;
                this.updateKoDelayed = false;
                this.loading = false;
              })
              .catch((err) => {
                this.loading = false;
                this.updateOk = false;
                this.updateKo = true;
                this.updateOkDelayed = false;
                this.updateKoDelayed = true;
                let msg = err?.response?.data?.error || `${i18nJS.errors.critical_error}: ${err.message}`;
                if (err.response.status === 401) {
                  msg = i18nJS.access_denied;
                }
                Utils.appendToFlash('error', escapeHtml(msg));
              });
          }
        } else if (this.updateOk) {
          this.resetPreview();
        } else {
          this.loading = true;
          axios
            .get(Route.GUEST_DRUG_SWAP, {
              responseType: 'json',
              params: {
                d_id_source: this.drugsFrom,
                d_id_dest: this.drugsTo,
                swap_from: this.swap_from,
              },
            })
            .then((res) => {
              this.$set(this, 'guestDrugs', res.data);
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
            });
        }
      }
    },
    closeError() {
      this.updateKo = false;
      Utils.clearNotice();
    },
    drugSourceSelected() {
      this.resetPreview();
      $('#drugsTo--select').trigger('change');
      this.guestDrugsInvolvedCount = null;
      this.loading = true;
      axios
        .get(Route.GUEST_DRUG_SWAP, {
          responseType: 'json',
          params: {
            d_id_source: this.drugsFrom,
            d_id_dest: this.drugsTo,
            swap_from: this.swap_from,
            count: true,
          },
        })
        .then((res) => {
          this.guestDrugsInvolvedCount = res.data.count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    fromTo(gd, preview = false) {
      let res = `${i18nJS.from} ${gd.datein}`;
      if (preview) {
        let endDate = moment(this.swap_from, window.i18nJS.time.formats.date_only);
        if (gd.dateout && moment(gd.dateout, window.i18nJS.time.formats.date_only).toDate() < endDate.toDate()) {
          endDate = moment(gd.dateout, window.i18nJS.time.formats.date_only);
        }
        res += ` ${i18nJS.to} ${endDate.format(window.i18nJS.time.formats.date_only)}`;
      } else if (gd.dateout) {
        res += ` ${i18nJS.to} ${moment(gd.dateout, window.i18nJS.time.formats.date_only).format(window.i18nJS.time.formats.date_only)}`;
      }
      return res;
    },
    fromToNew(gd) {
      const dateFromNew =
        moment(gd.datein, window.i18nJS.time.formats.date_only).toDate() < moment(this.swap_from, window.i18nJS.time.formats.date_only)
          ? this.swap_from
          : gd.datein;
      let res = `${i18nJS.from} ${moment(dateFromNew, window.i18nJS.time.formats.date_only).format(window.i18nJS.time.formats.date_only)}`;
      if (gd.dateout) {
        res += ` ${i18nJS.to} ${moment(gd.dateout, window.i18nJS.time.formats.date_only).format(window.i18nJS.time.formats.date_only)}`;
      }
      return res;
    },
    resetPreview() {
      this.$set(this, 'guestDrugs', []);
      this.updateOk = false;
      this.updateKo = false;
      this.updateOkDelayed = false;
      this.updateKoDelayed = false;
    },
    swapDateChange(val) {
      const valAsDate = moment(val, window.i18nJS.time.formats.date_only);
      if (this.minDate <= valAsDate) {
        this.swap_from = val;
      } else {
        this.swap_from = moment.utc(this.minDate).format(i18nJS.time.formats.date_only);
        this.updateDate = !this.updateDate;
      }
      this.resetPreview();
      if (this.drugsFrom) {
        this.drugSourceSelected();
      }
    },
    toBeClosed(gd) {
      return (
        moment(gd.datein, window.i18nJS.time.formats.date_only).toDate() < moment(this.swap_from, window.i18nJS.time.formats.date_only)
      );
    },
    toggleAll() {
      this.selGuestDrugs.length ? this.deselectAll() : this.selectAll();
    },
    deselectAll() {
      this.guestDrugs.forEach((guestDrug) => (guestDrug.selected = false));
    },
    selectAll() {
      this.guestDrugs.forEach((guestDrug) => {
        this.selGuestDrugs.push(guestDrug.id);
        guestDrug.selected = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.select2-container {
  margin: auto;
  width: 90% !important;
}
.forbidden {
  cursor: not-allowed;
}
.content {
  width: 100%;
}
.config-row {
  display: flex;
  justify-content: space-between !important;
  margin: auto;
  & > .config-col {
    display: flex;
    margin: auto;
    flex-direction: column;
    width: 100%;
    text-align: center;
    vertical-align: middle;
    &.middle {
      width: 20%;
    }
    &.swap_from {
      text-align: left;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 1em;
    }
  }
}
.cta {
  width: 20em;
}
.preview-area > ol {
  background-color: #fff;
  border-radius: 10px;
  margin: auto;
  padding: 1em;

  & > li {
    border-bottom: 1px solid #333;
    display: flex;
    justify-content: space-between;
    padding: 0.5em 1em;

    &.header {
      background-color: #bce8f1;
      border-radius: 10px 10px 0 0;
      & > * {
        font-weight: bold;
      }
    }
    &:nth-child(even) {
      background-color: #eee;
    }
  }
}
.gd-involved,
li.header {
  & > .sel {
    width: 5%;
  }
  & > .fn {
    font-weight: bold;
    width: 30%;
  }
  & > .via-and-form,
  & > .drug-and-periodicity {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  & > .via-and-form {
    width: 5%;
    & > .form {
      color: #3572b0;
      font-style: italic;
      font-size: 0.8em;
    }
  }
  & > .drug-and-periodicity {
    width: 40%;
  }
}
.guest_drugs_involved_count {
  height: 1em;
  margin: auto;
  padding: 1em;
}
.preview-area {
  border: 1px solid #aaa;
  border-radius: 10px;
  background-color: #eee;
  padding: 1em;
  position: relative;
  min-height: 6em;
}
.swap_from-row {
  height: 4em;
}

.from--therapy,
.to--therapy {
  border-radius: 10px;
  padding: 0.5em;
}

.from--therapy {
  border: 1px solid #aaa;
  background-color: #ccc;
  margin-bottom: 2em;
  position: relative;
  &:after {
    content: '\f354';
    font-family: 'Font Awesome 6 Pro';
    font-weight: 200;
    height: 2em;
    position: absolute;
    bottom: -2.5em;
    width: 100%;
    text-align: center;
  }
}

.to--therapy {
  border: 1px solid #1b1;
  background-color: #cfc;
}

/* Checked */
input[type='checkbox']:checked + label,
label.cb-label.before--free-text.checked {
  &:before {
    content: '✔';
    padding-left: 3px;
    color: #06d544;
    line-height: 1.3em;
  }
}
.sel > label {
  display: inline-flex;
  position: relative;
  padding-left: 2em;
  padding-right: 1em;
  line-height: 2;
  z-index: 1;
  cursor: pointer;
}
label.cb-label:before {
  box-sizing: border-box;
  content: ' ';
  position: absolute;
  top: 0.3em;
  left: 0;
  display: block;
  width: 1.4em;
  height: 1.4em;
  border: 2px solid #bbb;
  border-radius: 0.25em;
  z-index: -1;
}

input[type='checkbox']:checked + label {
  padding-left: 2em;
  padding-right: 1em;
  z-index: 1;
  cursor: pointer;

  &.before--free-text {
    padding: 0.5em;
  }
}

input[type='checkbox'],
input[type='radio'] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.label__checkbox {
  display: none;
}

.label__check,
.label__check_ko {
  display: inline-block;
  border-radius: 50%;
  border: 5px solid rgba(0, 0, 0, 0.1);
  background: white;
  vertical-align: middle;
  margin-right: 20px;
  width: 2em;
  height: 2em;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border 0.3s ease;

  i.icon {
    opacity: 0.2;
    font-size: 'calc(1rem + 1vw)';
    color: transparent;
    transition: opacity 0.3s 0.1s ease;
    -webkit-text-stroke: 3px rgba(0, 0, 0, 0.5);
  }

  &:hover {
    border: 5px solid rgba(0, 0, 0, 0.2);
  }
}

.label__checkbox:checked + .label__text .label__check,
.label__checkbox:checked + .label__text .label__check_ko {
  animation: check 0.5s cubic-bezier(0.895, 0.03, 0.685, 0.22) forwards;

  .icon {
    opacity: 1;
    transform: scale(0);
    color: white;
    -webkit-text-stroke: 0;
    animation: icon 0.3s cubic-bezier(1, 0.008, 0.565, 1.65) 0.1s 1 forwards;
  }
}

.label__checkbox:checked + .label__text .label__check_ko {
  animation: checkKo 0.5s cubic-bezier(0.895, 0.03, 0.685, 0.22) forwards;
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  & > label {
    background-color: inherit;
    font-size: 3em;
  }
}

@keyframes icon {
  from {
    opacity: 0;
    transform: scale(0.3);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes check {
  0% {
    width: 1.5em;
    height: 1.5em;
    border-width: 5px;
  }
  10% {
    width: 1.5em;
    height: 1.5em;
    opacity: 0.1;
    background: rgba(0, 0, 0, 0.2);
    border-width: 15px;
  }
  12% {
    width: 1.5em;
    height: 1.5em;
    opacity: 0.4;
    background: rgba(0, 0, 0, 0.1);
    border-width: 0;
  }
  50% {
    width: 2em;
    height: 2em;
    background: #00d478;
    border: 0;
    opacity: 0.6;
  }
  100% {
    width: 2em;
    height: 2em;
    background: #00d478;
    border: 0;
    opacity: 1;
  }
}

@keyframes checkKo {
  0% {
    width: 1.5em;
    height: 1.5em;
    border-width: 5px;
  }
  10% {
    width: 1.5em;
    height: 1.5em;
    opacity: 0.1;
    background: rgba(0, 0, 0, 0.2);
    border-width: 15px;
  }
  12% {
    width: 1.5em;
    height: 1.5em;
    opacity: 0.4;
    background: rgba(0, 0, 0, 0.1);
    border-width: 0;
  }
  50% {
    width: 2em;
    height: 2em;
    background: #f45b65;
    border: 0;
    opacity: 0.6;
  }
  100% {
    width: 2em;
    height: 2em;
    background: #f45b65;
    border: 0;
    opacity: 1;
  }
}
</style>
